/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-16 11:20:10
 *
 *******************************************************/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import _ from 'lodash';
import { getFormValues } from 'redux-form';
import * as ProductActions from 'src/stores/actions/product-actions';
import BundlePreview from './preview';

class BundlePreviewVisualEditor extends Component<ComposedProps, State> {
  componentDidMount() {
    const { getPreviewProducts } = this.props;
    getPreviewProducts('', 0, 20, true);
  }

  sortProducts(products) {
    const productsWithImages = [];
    const productsWithoutImages = [];
    for (let i = 0; i < products.length; i++) {
      if (products[i].images && Object.keys(products[i].images).length > 0) {
        productsWithImages.push(products[i]);
      } else {
        productsWithoutImages.push(products[i]);
      }
    }
    return [...productsWithImages, ...productsWithoutImages];
  }
  
  render() {
    const { formValues, previewProducts } = this.props;
    const { numberOfRecommendProduct } = formValues;
    const products = [...this.sortProducts(previewProducts)];
    products.length =
      previewProducts.length >= numberOfRecommendProduct + 1
        ? numberOfRecommendProduct + 1
        : previewProducts.length;
    return (
      <div className="recommendation-bundle">
        {previewProducts.length > 0 && (
          <BundlePreview
            formValues={formValues}
            products={products}
            previewProducts={this.sortProducts(previewProducts)}
          />
        )}
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => ({
  getPreviewProducts: (q, skip, limit, isSourceProduct) =>
    dispatch(
      ProductActions.getProducts(
        {
          q,
          skip,
          limit,
          feature: ''
        },
        ownProps.i18n
      )
    )
});
const mapStateToProps = (state, props) => {
  const formValues = getFormValues('VisualEditorForm')(state);

  return {
    formValues,
    previewProducts: _.get(state, 'product.products', []),
    tenantApp: _.get(state.oauth, 'tenantApp', {}),
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(BundlePreviewVisualEditor));
